module.exports = __webpack_public_path__ + "img/LegendOfNowhere.1072008f.png";